import { LoaderPageContainer, toast } from '@livable/saas-react-components';
import React, { useEffect } from 'react';
import { track, events } from 'src/configs/amplitude';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Typography, LinearProgress, Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import useStyles from './styles';
import { AUTH_TOKEN_KEYS } from 'src/constants/authToken';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { parseJwt } from 'src/core/services/jwt';
import { IS_PAYMENT_METHOD } from 'src/constants/payments';
export const ConfirmAccountPage = observer(() => {
  const store = useStore();
  const classes = useStyles();
  const navigate = useNavigate();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const page = 'Confirm Account';
  const searchParams = new URLSearchParams(window.location.search);
  const data = {
    email: searchParams.get('email') ? searchParams.get('email').replace(' ', '+') : null,
    confirmationCode: searchParams.get('confirmationCode')
  };
  const currentSessionUserEmail = localStorage.getItem(AUTH_TOKEN_KEYS.accessToken) ? parseJwt(localStorage.getItem(AUTH_TOKEN_KEYS.accessToken)).email : null;
  const isAutoConfirmType = data.email === currentSessionUserEmail || !localStorage.getItem(AUTH_TOKEN_KEYS.accessToken);
  const handleConfirm = async () => {
    const resp = await store.account.confirmAnAccountsEmailAsync.run(data);
    await store.account.logoutAccountAsync.run();
    if (resp) {
      toast('success', {
        body: ['Successfully confirmed! To continue - please log in.']
      }); // ? i18n
    }
    track(events.clicked('Logout'), {
      page
    });
    navigate('/login');
  };
  const handleReject = () => {
    track(events.clicked('Keep Working'), {
      page
    });
    navigate('/');
  };
  useEffect(() => {
    if (!data.email || !data.confirmationCode) {
      navigate('/');
      return;
    }
    const confirmAccount = async userData => {
      const resp = await store.account.confirmAnAccountsEmailAsync.run(userData);
      return resp;
    };
    const refreshUserData = async () => {
      const resp = await store.account.getProfileAsync.run();
      return resp;
    };
    if (isAutoConfirmType) {
      confirmAccount(data).then(async response => {
        if (!response) {
          toast('error', store.account.confirmAnAccountsEmailAsync.error.errorResp);
          navigate('/login');
          return;
        }
        if (!!localStorage.getItem(AUTH_TOKEN_KEYS.refreshToken)) await store.account.refreshAccessTokenAsync.run();
        localStorage.removeItem(USER_SETTINGS_KEYS.confirmation);
        if (!localStorage.getItem(AUTH_TOKEN_KEYS.accessToken)) {
          toast('success', {
            body: ['Successfully confirmed! To continue - please log in.']
          }); // ? i18n

          navigate('/login');
        } else {
          await refreshUserData();
          localStorage.setItem(IS_PAYMENT_METHOD, 'false');
          try {
            const hsResp = await store.hubspot.getHubspotTokenAsync.run();
            if (hsResp && hsResp.isSuccessful) {
              window.hsConversationsSettings = {
                identificationEmail: hsResp.response.email,
                identificationToken: hsResp.response.token
              };
              window.HubSpotConversations.resetAndReloadWidget();
            }
          } catch (error) {}
          navigate('/mfa');
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(LoaderPageContainer, null, !isAutoConfirmType && /*#__PURE__*/React.createElement("div", {
    className: classes.loaderWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    marginBottom: "18px"
  }, t('sign_up_flow.to_your_attention')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    marginBottom: "48px",
    className: classes.additionalInfo
  }, t('sign_up_flow.active_session_warning')), /*#__PURE__*/React.createElement("div", {
    className: classes.controllers
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: handleConfirm,
    'custom-attribute': '526-confirm-account-page'
  }, t('buttons.confirm_and_logout')), /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleReject,
    'custom-attribute': '527-confirm-account-page'
  }, t('buttons.continue_working')))), isAutoConfirmType && /*#__PURE__*/React.createElement("div", {
    className: classes.loaderWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    marginBottom: "18px"
  }, t('general.processing')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    marginBottom: "48px",
    className: classes.additionalInfo
  }, t('general.may_take_a_while')), /*#__PURE__*/React.createElement(LinearProgress, null)));
});